module.exports = new __parcel__URL__("project-list-sidebar-app-skeleton.tpl.35da4e26.svg").toString();